import React from "react";

import css from "./chat_message.scss";

type Props = {
  attachmentName: string;
};

export const MessageAttachment = ({ attachmentName }: Props): JSX.Element => (
  <span className={css.messageAttachment}>{attachmentName}</span>
);
